import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createLegalEntityEin,
  updateLegalEntityEin,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const useLegalEntityEinDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const legalEntityEinDispatch = ({ data, defaultValues, onSuccess }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data: {
        Ein: !data.NoEin ? '' : data.Ein,
      },
      onSuccess,
    };

    if (defaultValues?.Ein || !defaultValues?.NoEin) {
      dispatch(
        updateLegalEntityEin({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createLegalEntityEin({
        ...requestData,
      }),
    );
  };

  return { legalEntityEinDispatch };
};

export default useLegalEntityEinDispatch;
